import React, { ReactNode } from 'react';
import styles from './PremiumLock.module.css';

interface PremiumLockProps {
  children: ReactNode;
  isLocked: boolean;
  message?: string;
  onLockedClick?: () => void;
}

/**
 * Overlay component that displays a lock icon and message over locked content
 * Used to indicate premium-only content to non-premium users
 */
export function PremiumLock({ 
  children, 
  isLocked, 
  message = 'Premium Access Required',
  onLockedClick 
}: PremiumLockProps) {
  // If not locked, just render children normally
  if (!isLocked) {
    return <>{children}</>;
  }

  return (
    <div className={styles.container}>
      {/* Render the underlying content */}
      <div className={styles.content}>
        {children}
      </div>
      
      {/* Overlay with lock icon */}
      <div 
        className={styles.overlay}
        onClick={(e) => {
          e.stopPropagation();
          onLockedClick?.();
        }}
        aria-label={message}
      >
        <span className={styles.lockIcon} aria-hidden="true">🔒</span>
      </div>
    </div>
  );
}